/**
 * AuthCard - the sign-in / signup container.
 *
 * Deliberately unlike the rest of the product. It is the only place that uses
 * the 24px radius, and the only card whose fill is the app background rather
 * than the card colour: on the auth wash a lighter card looks pasted on. The
 * title is 30px at weight 500 where everything else is 600.
 *
 * @param {Object} props
 * @param {string} props.title - card title
 * @param {string} [props.subtitle]
 * @param {React.ReactNode} [props.logo] - rendered above the title
 * @param {React.ReactNode} props.children - card content
 * @param {string} [props.className]
 */
export function AuthCard({ title, subtitle, logo, children, className = '' }) {
  return (
    <div
      className={`w-[90%] max-w-auth-card h-auto p-6 md:p-10 rounded-2xl bg-background border border-border shadow-theme-lg ${className}`}
    >
      {logo && <div className="flex justify-center mb-8">{logo}</div>}

      {title && (
        <div className="text-center mb-10">
          <h1 className="text-3xl font-medium tracking-tight text-foreground mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-foreground-secondary">{subtitle}</p>
          )}
        </div>
      )}

      {children}
    </div>
  );
}

export default AuthCard;
